module.exports = __webpack_public_path__ + "img/aoxintong.b50582d7.png";